import { render, staticRenderFns } from "./ChevronRightIcon.vue?vue&type=template&id=b3c2ff72&scoped=true&"
import script from "./ChevronRightIcon.vue?vue&type=script&lang=js&"
export * from "./ChevronRightIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChevronRightIcon.vue?vue&type=style&index=0&id=b3c2ff72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c2ff72",
  null
  
)

export default component.exports